import axiosInstance from "@/lib/axios";
import type { MeResponse } from "./me.dto";

const END_POINT = "/api/user/me";

export const meApi = async () => {
  return await axiosInstance.get<MeResponse>(END_POINT);
};
